import React, { useMemo, useState, useEffect } from 'react'
import intl from 'react-intl-universal'
import { Stepper } from 'antd-mobile'
import { useDispatch, useSelector } from 'react-redux'
import { setProductAttr, selectProductAttr, resetCart } from '../../store/reducers/cart'
import CurrencySymbol from '../CurrencySymbol'
import styles from './index.module.less'
import { formatNumber } from '../../utils/math'
import { getAttrOriginUnitPrice, getAttrUnitPrice, shouldShowPackageDiscount } from '../../utils/price'

// 自定义 Hook 处理属性选择逻辑
const useAttrSelection = (normalArr, attr) => {
    const [attrKeyArr, setAttrKeyArr] = useState([])
    const dispatch = useDispatch()

    const updateCart = (arr) => {
        const newAttr = {
            attrArr: arr,
            attrKeys: arr.map(item => item.productExtraAttrKey).join(),
            subAttrKeys: arr.map(item => item.productExtraAttrSubKey).join()
        }
        dispatch(setProductAttr(newAttr))
    }

    const handleStepperChange = (value, subAttr, optionalNum) => {
        if (value === 0) {
            setAttrKeyArr(prev => {
                const newArr = prev.filter(item =>
                    item.productExtraAttrSubKey !== subAttr.productExtraAttrSubKey ||
                    item.productExtraAttrKey !== subAttr.productExtraAttrKey
                )
                updateCart(newArr)
                return newArr
            })
        } else {
            setAttrKeyArr(prev => {
                const isExist = prev.some(item =>
                    item.productExtraAttrSubKey === subAttr.productExtraAttrSubKey &&
                    item.productExtraAttrKey === subAttr.productExtraAttrKey
                )

                let newArr
                if (isExist) {
                    newArr = prev.map(item =>
                        item.productExtraAttrSubKey === subAttr.productExtraAttrSubKey &&
                            item.productExtraAttrKey === subAttr.productExtraAttrKey
                            ? { ...item, quantity: value }
                            : item
                    )
                } else {
                    newArr = [...prev, { ...subAttr, quantity: value }]
                }
                updateCart(newArr)
                return newArr
            })
        }
    }

    const handleAttrClick = (subAttr) => {
        if (attrKeyArr.length === 0) {
            handleStepperChange(1, subAttr)
            return
        }

        const isExist = attrKeyArr.some(item => item.productExtraAttrKey === subAttr.productExtraAttrKey)
        if (isExist) {
            const nList = attrKeyArr.filter(item => item.productExtraAttrKey !== subAttr.productExtraAttrKey)
            const arr = [...nList, { ...subAttr, quantity: 1 }]
            setAttrKeyArr(arr)
            updateCart(arr)
        } else {
            handleStepperChange(1, subAttr)
        }
    }

    const isAttrSelected = (subAttr) => {
        return attrKeyArr.some(item =>
            item.productExtraAttrSubKey === subAttr.productExtraAttrSubKey &&
            item.productExtraAttrKey === subAttr.productExtraAttrKey
        )
    }

    useEffect(() => {
        let initialAttrs = []
        if (normalArr?.length > 0) {
            // const list = product.attrs.filter(attr => attr.subAttrList.some(subAttr => subAttr.stock > 0 || subAttr.stock === -1))
            // console.log(list,'=====///=======list====')

            normalArr.forEach(attr => {
                const subAttr = attr.subAttrList.find(subAttr => subAttr.stock > 0 || subAttr.stock === -1)
                if (subAttr) {

                    /*mark 20260630 不需要默认选中
                    // initialAttrs.push({
                    //     ...subAttr,
                    //     quantity: attr.optionalNum === 1 ? 1 : 0
                    // })
                    //*/
                }
            })

            // initialAttrs = product.attrs.map(attr => {
            //     const subAttr = attr.subAttrList.find(subAttr => subAttr.stock > 0 || subAttr.stock === -1)
            //     return {
            //         ...subAttr,
            //         quantity: 1
            //     }
            // })
        }
        setAttrKeyArr(initialAttrs)
        updateCart(initialAttrs)
        return () => {
            updateCart([])
            setAttrKeyArr([])
        }
    }, [normalArr])

    return {
        attrKeyArr,
        handleStepperChange,
        handleAttrClick,
        isAttrSelected
    }
}

// 属性项组件
const AttrItem = React.memo(({ attr, attrKeyArr, onStepperChange, onAttrClick, isAttrSelected }) => {
    const { optionalNum, subAttrList } = attr

    const maxNum = attrKeyArr.reduce((acc, item) => {
        return acc + item.quantity
    }, 0)

    if (optionalNum === -1 || optionalNum > 1) {
        return (
            <div className={styles.moreAttrBox}>
                {subAttrList?.map((subAttr, subIndex) => {
                    const item = attrKeyArr.find(item =>
                        item.productExtraAttrSubKey === subAttr.productExtraAttrSubKey &&
                        item.productExtraAttrKey === subAttr.productExtraAttrKey
                    )
                    return (
                        <div className={`${styles.moreAttrItem} jm-flex`} key={subIndex}>
                            <div className={`${styles.moreAttrItem} jm-flex-item`}>
                                {subAttr.productExtraAttrSubName}
                            </div>
                            <div className='jm-price'>
                                <b><CurrencySymbol currency={subAttr.currency} /> {formatNumber(getAttrUnitPrice(subAttr))}</b>
                                {shouldShowPackageDiscount(subAttr) ? (
                                    <small style={{ display: 'block', color: '#777', textDecoration: 'line-through', fontWeight: 400 }}>
                                        <CurrencySymbol currency={subAttr.currency} /> {formatNumber(getAttrOriginUnitPrice(subAttr))}
                                    </small>
                                ) : null}
                            </div>
                            <div style={{ minWidth: 60 }}>
                                {
                                    (subAttr.stock > 0 || subAttr.stock === -1)
                                        ?
                                        <Stepper
                                            inputReadOnly
                                            min={0}
                                            max={subAttr.stock === -1 ? 99 : subAttr.stock}
                                            value={item?.quantity || 0}
                                            onChange={value => {
                                                if (value > (item?.quantity || 0) && optionalNum !== -1) {
                                                    const currentTotal = attrKeyArr.filter(item => item.productExtraAttrKey === attr.attrKey).reduce((acc, curr) => {
                                                        if (curr.productExtraAttrSubKey === subAttr.productExtraAttrSubKey) {
                                                            return acc;
                                                        }
                                                        return acc + curr.quantity;
                                                    }, 0);

                                                    // console.log(currentTotal, value,attr, '=====///=======currentTotal====')

                                                    if (currentTotal + value > optionalNum) {
                                                        return;
                                                    }
                                                }
                                                onStepperChange(value, subAttr);
                                            }}
                                        />
                                        : <small style={{ color: '#999' }}>Sold Out</small>
                                }

                            </div>
                        </div>
                    )
                })}
            </div>
        )
    }

    return (
        <ul className={styles.subAttrList}>
            {subAttrList?.map((subAttr, subIndex) => (
                <li
                    key={subIndex}
                    className={`${isAttrSelected(subAttr) ? styles.current : ''} ${subAttr.stock === 0 ? styles.soldOut : ''}`}
                    onClick={() => {
                        if (subAttr.stock > 0 || subAttr.stock === -1) {
                            onAttrClick(subAttr)
                        }
                    }}
                >
                    {subAttr.productExtraAttrSubName}
                </li>
            ))}
        </ul>
    )
})

export default function NormalAttrContent({ product, normalArr }) {
    const attr = useSelector(selectProductAttr)
    const {
        attrKeyArr,
        handleStepperChange,
        handleAttrClick,
        isAttrSelected
    } = useAttrSelection(normalArr, attr)

    return (
        <div>
            {normalArr?.map((attr, index) => (
                <div key={index} className={styles.attrItem}>
                    <div className={`${styles.attrTitle} ${styles.modalTitle}`}>
                        {attr.attrName || '-'}
                        {attr.optionalNum > 1 &&
                            <span className={styles.optionalNum}>
                                ({intl.get('should_select_number').d('应选择的数量')}:{attr.optionalNum})
                            </span>
                        }
                    </div>
                    <AttrItem
                        attr={attr}
                        attrKeyArr={attrKeyArr}
                        onStepperChange={handleStepperChange}
                        onAttrClick={handleAttrClick}
                        isAttrSelected={isAttrSelected}
                    />
                </div>
            ))}
        </div>
    )
}
